import { OidcClient } from '@axa-fr/react-oidc';
import { DEFAULT_LANG, I18N_KEY } from '@healthhub/react-ui';
import axios from 'axios';

import { LayoutViewBridge } from '@shared/context';

import { handleAuthError } from './handlers/handleAuthError/handleAuthError';
import type { CustomAxiosRequestConfig } from './types';

const initializeAxiosInterceptor = () => {
  axios.interceptors.request.use((config) => {
    if ((config as CustomAxiosRequestConfig)?.skipRequestInterceptor) {
      return config;
    }

    config.data = {
      ...config?.data,
      Language: localStorage.getItem(I18N_KEY) ?? DEFAULT_LANG,
    };

    return config;
  });
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const { isPortalView, isMobileView } = LayoutViewBridge.getLayoutViewBridge?.() ?? {};
      const oidc = OidcClient.get();
      const isUnauthorised = error?.response?.status === 401;
      const isForbidden = error?.response?.status === 403;

      if (!(isUnauthorised || isForbidden) || (isPortalView && !oidc.tokens)) {
        return Promise.reject(error);
      }

      await handleAuthError({
        isForbidden,
        isMobileView,
        isPortalView,
        isUnauthorised,
        oidc,
      });
      return false;
    }
  );
};

export { initializeAxiosInterceptor };
